import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';
import { PendingPaymentsResponse } from 'src/app/models/IPendingPaymentsResponse';

@Injectable({
  providedIn: 'root'
})
export class DashboardUgService {

  private baseURL = environment.apiURL;

  constructor(private http: HttpClient, private errorHandler: ConfigErrorHandler) { }

  /**
   * Count units in supplier stock
   * @returns Array
   */
  public countUnitsInSupplierStock():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-units-in-supplier-stock`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count units en route
   * @returns Array
   */
  public countUnitsEnroute():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-units-en-route`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count vehicles at CFS
   * @returns Array
   */
  public countUnitsAtCFS():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-units-at-cfs`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count units in transit to Uganda
   * @returns Array
   */
  public countUnitsInTransitToUganda():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-units-in-transit-to-ug`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get total stock by location
   * @returns Array
   */
  public totalStockByLocation():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/get-total-stock-by-location`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count pending payments per category
   * @returns Array
   */
  public countPendingPayments(): Observable<PendingPaymentsResponse> {

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-pending-payments`;

    return this.http.get<PendingPaymentsResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

   /**
     * Count available stock by make
     * @returns Array
     */
    public countAvailableStockByMake():Observable<ApiResponse>{

      let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-available-stock-by-make`;

      return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

    }

    /**
   * Count available stock by make for branch
   * @returns Array
   */
  public countAvailableStockByMakeForBranch(branchId: string|null):Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-available-stock-by-make-for-branch/${branchId}`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get branches with locations
   * @returns Array
   */
  public getBranches():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/shared/branches-with-location`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Count available stock by model
   * @returns Array
   */
  public countAvailableStockByModel(make_id:string,branchId:string|null):Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/count-available-stock-by-model/${make_id}/${branchId}`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Gets units under the selected model
   * @returns Array
   */
  public getUnitsByModel(model_id:string,branchId:string|null):Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/get-units-by-model/${model_id}/${branchId}`;

    return this.http.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Get due payments
   */
  public getDueDutyPayments() {

    let apiURL:string=`${this.baseURL}/v1/dashboard/ug/due-duty-payments`;

    return this.http.get(apiURL).pipe(catchError(this.errorHandler.handleError));

  }
}
